import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1387_17267)" }, [
  /* @__PURE__ */ createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.738 1.07982C15.062 2.05582 16.058 3.60282 16.543 5.43682C17.027 7.27182 16.928 9.11582 16.263 10.6318C15.585 12.1778 14.376 13.2558 12.86 13.6678C11.523 14.0308 10.137 13.8238 8.903 13.0878L10.093 18.7398L5.455 19.9998L0 2.93682L6.398 1.19982L6.574 2.03682C7.245 1.12834 8.20249 0.472399 9.292 0.174817C10.808 -0.237183 12.388 0.0848168 13.738 1.07982ZM16.953 13.4328C18.407 13.4328 19.585 14.6268 19.585 16.0998C19.585 17.5728 18.407 18.7668 16.953 18.7668C15.5 18.7668 14.322 17.5728 14.322 16.0998C14.322 14.6268 15.5 13.4328 16.953 13.4328ZM27.672 0.392817C29.242 0.392817 30.685 1.11782 31.735 2.43282C32.763 3.72282 33.33 5.47882 33.33 7.37782C33.33 9.27782 32.764 11.0338 31.735 12.3228C30.685 13.6388 29.242 14.3628 27.672 14.3628C26.287 14.3628 25.002 13.7988 23.998 12.7628L23.704 18.5358H19.321C19.6413 18.2164 19.8952 17.8369 20.0682 17.419C20.2412 17.0011 20.3298 16.5531 20.329 16.1008C20.3301 15.5 20.1734 14.9094 19.8745 14.3881C19.5757 13.8669 19.1451 13.4333 18.626 13.1308L17.991 0.624817H24.615L24.572 1.47782C25.4531 0.776501 26.5459 0.393397 27.672 0.392817ZM25.997 5.36482C25.003 5.36482 24.194 6.26882 24.194 7.37782C24.194 8.48782 25.004 9.39082 25.997 9.39082C26.99 9.39082 27.798 8.48782 27.798 7.37782C27.798 6.26782 26.99 5.36482 25.997 5.36482ZM8.944 5.41582C7.985 5.67582 7.435 6.75982 7.718 7.83282C8.002 8.90482 9.013 9.56482 9.973 9.30482C10.932 9.04482 11.482 7.95982 11.199 6.88782C10.916 5.81582 9.904 5.15582 8.944 5.41582Z",
    fill: "#4848FF"
  })
], -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("defs", null, [
  /* @__PURE__ */ createElementVNode("clipPath", { id: "clip0_1387_17267" }, [
    /* @__PURE__ */ createElementVNode("rect", {
      width: "34",
      height: "20",
      fill: "white"
    })
  ])
], -1);
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 20",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_3);
}
const icV2StovePpoolPpColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2StovePpoolPpColor as default
};
